export default __webpack_public_path__ + "static/media/71.fac0772b.gif";